(function () {
  var config = window.statsigConfig;
  if (!config || !config.clientKey) return;

  var botPattern = /bot|crawler|spider|crawling|googlebot|bingbot|slurp|duckduckbot|baidu|yandex|facebot|ia_archiver/i;
  if (botPattern.test(navigator.userAgent)) return;

  function initStatsig() {
    // The early-init script in <head> may have already created the client and
    // started initializeAsync(). If so, reuse it; otherwise create it now as
    // a fallback (e.g. if the SDK loaded after this defer script ran).
    var client = window.__statsigClient;
    if (!client) {
      client = new Statsig.StatsigClient(config.clientKey, config.user, {
        environment: { tier: 'production' }
      });
      window.__statsigClient = client;
      client.initializeAsync().then(function () {
        window.__statsigReady = true;
        clearTimeout(window.__statsigAntiFlickerTimeout);
        document.documentElement.classList.remove('statsig-loading');
        wireEvents(client);
      });
      return;
    }

    // Client already created by early init — wait for its async to complete,
    // then wire up event logging.
    if (window.__statsigReady) {
      wireEvents(client);
    } else {
      var iv = setInterval(function () {
        if (window.__statsigReady) { clearInterval(iv); wireEvents(client); }
      }, 50);
    }
  }

  function wireEvents(client) {
      clearTimeout(window.__statsigAntiFlickerTimeout);
      document.documentElement.classList.remove('statsig-loading');

      var sid = client.getContext().stableID || null;
      var clientType = window.isTaminzoApp === 'ios' ? 'ios_app'
                     : window.isTaminzoApp === 'android' ? 'android_app'
                     : 'web';

      if (sid) {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { '_statsig_sid': sid, '_client_type': clientType } })
        });
      }

      var meta = config.pageMeta;

      var isFirstPage = !sessionStorage.getItem('statsig_page_count');
      var alreadyEngaged = !!sessionStorage.getItem('statsig_session_engaged');

      if (isFirstPage) {
        sessionStorage.setItem('statsig_page_count', '1');
        sessionStorage.setItem('statsig_landing_page', window.location.pathname);
        sessionStorage.setItem('statsig_landing_title', document.title);
      }

      client.logEvent('page_view', window.location.pathname, {
        title: document.title,
        referrer: document.referrer,
        page_type: meta.page_type,
        landing_page: sessionStorage.getItem('statsig_landing_page') || '',
        landing_title: sessionStorage.getItem('statsig_landing_title') || '',
        client_type: clientType
      });

      if (!isFirstPage && !alreadyEngaged) {
        sessionStorage.setItem('statsig_session_engaged', '1');
        client.logEvent('session_engaged', window.location.pathname, {
          page_type: meta.page_type,
          landing_page: sessionStorage.getItem('statsig_landing_page') || '',
          landing_title: sessionStorage.getItem('statsig_landing_title') || '',
          client_type: clientType
        });
      }

      if (meta.page_type === 'product') {
        client.logEvent('product_viewed', meta.product_title, {
          product_id: meta.product_id,
          vendor: meta.product_vendor,
          product_type: meta.product_type,
          variant_id: meta.variant_id,
          price: meta.price,
          currency: meta.currency,
          client_type: clientType
        });
      }

      if (meta.page_type === 'collection') {
        client.logEvent('collection_viewed', meta.collection_title, {
          collection_id: meta.collection_id,
          products_count: meta.products_count,
          client_type: clientType
        });
      }

      if (meta.page_type === 'search' && meta.search_term) {
        client.logEvent('search_performed', meta.search_term, {
          results_count: meta.results_count,
          client_type: clientType
        });
      }

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
          if (event && event.source === 'product-form') {
            var cartData = event.cartData || {};
            fetch('/cart.js')
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                client.logEvent('add_to_cart', cartData.product_title || '', {
                  variant_id: String(cartData.variant_id || ''),
                  quantity: String(cartData.quantity || 1),
                  price: String(cartData.presentment_price || ''),
                  line_total: String(cartData.line_price || ''),
                  cart_total: String(cart.total_price || ''),
                  client_type: clientType
                });
              });
          }
        });
      }
  }

  var sdkScript = document.querySelector('script[src*="statsig-js-client"]');
  if (window.Statsig) { initStatsig(); }
  else if (sdkScript) { sdkScript.addEventListener('load', initStatsig); }
})();
